/**
 * Freeform ajax submissions and validation
 */

let Forms = (function() {

    'use strict';

    /*
     * Start with init Function
     */
    function init() {

        let forms = document.querySelectorAll('[data-freeform]');

        Array.prototype.forEach.call(forms, form => {

            // refresh CSRF and other tokens for the form handle
            refreshTokens(form);

            // setup form options (listeners)
            configureForm(form);

            // setup stripe options (listeners)
            configureStripe(form);

        });
    }

    function refreshTokens(form) {

        let formHandle = form.dataset.handle;

        // when the first required field is focussed by a user, refresh tokens
        let firstInput = form.querySelectorAll('label.is-required + input[type=text],input[type=text][required]')[0];
        if (firstInput) {

            // we have to refresh tokens for *all* forms in the page using the same handle
            // - even if the user hasn't interacted with them, we have to assume they might
            let request = new XMLHttpRequest();

            firstInput.addEventListener('focus', (e) => {

                request.onload = () => {
                    let data = JSON.parse(request.response);
                    let forms = document.querySelectorAll('[data-freeform][data-handle=' + formHandle + ']');
                    Array.prototype.forEach.call(forms, form => {

                        // Update the Form Hash
                        //form.querySelector('input[name=formHash]').value = data.hash;

                        // Update the Payload if encrypted payloads are enabled
                        //form.querySelector('input[name=freeform_payload]').value = data.payload;

                        // Locate and update the CSRF input
                        let csrf = data.csrf ?? null;
                        if (csrf) {
                            form.querySelector('input[name=' + csrf.name + ']').value = csrf.value;
                        }
                    });
                };

                request.open("GET", '/dynamic/form-tokens?form=' + formHandle);
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest");
                request.send();

            }, { once: true });
        }
    }

    function configureForm(form) {

        // Styling for AJAX responses
        form.addEventListener("freeform-ready", (event) => {
            let freeform = event.freeform;

            // scrolling offset in pixels from the top of the form.
            // #top is our page header element
            let header = document.getElementById('top');
            if (header) {
                // Determine padding to leave above form
                let paddingTop = 32;
                let mql = window.matchMedia("(min-width: 1280px)");
                if (mql.matches) {
                    paddingTop = 64;
                }
                event.options.scrollOffset = (header.offsetHeight + paddingTop) * -1;
            }
        });

        // Override the way field errors are displayed
        form.addEventListener('freeform-render-field-errors', (event) => {
            // Prevent the default behavior
            event.preventDefault();

            const errors = event.errors;
            const options = event.freeform.options;

            for (const key in errors) {
                if (!errors.hasOwnProperty(key) || !key) {
                    continue;
                }

                const messages = errors[key];
                const errorsList = document.createElement('ul');
                errorsList.classList.add(options.errorClassList);
                errorsList.setAttribute('data-field-errors', '');

                for (let messageIndex = 0; messageIndex < messages.length; messageIndex++) {
                    const message = messages[messageIndex];
                    const listItem = document.createElement('li');
                    listItem.appendChild(document.createTextNode(message));
                    //if (message !== 'This field is required') {
                    //    listItem.setAttribute('role', 'alert');
                    //    listItem.setAttribute('aria-live', 'polite');
                    //}
                    errorsList.appendChild(listItem);
                }

                const inputList = form.querySelectorAll(
                    '*[name=' + key + "], *[name='" + key + "[]']"
                );
                for (let inputIndex = 0; inputIndex < inputList.length; inputIndex++) {
                    const input = inputList[inputIndex];
                    const inputType= input.getAttribute('type');
                    if (inputType === 'radio') {
                        // Radios must be inside a container with [role="radiogroup"]
                        const radiogroup = input.closest('[role="radiogroup"]');
                        if (radiogroup) {
                            radiogroup.setAttribute('aria-invalid', 'true');
                            radiogroup.setAttribute('aria-describedby', 'errors-' + input.id);
                        }
                    } else {
                        input.setAttribute('aria-invalid', 'true');
                        input.setAttribute('aria-describedby', 'errors-' + input.id);
                    }
                    input.classList.add(options.errorClassField);
                    errorsList.setAttribute('id', 'errors-' + input.id);
                    //input.parentElement.appendChild(errorsList);
                    input.closest('[data-field-container="'+key+'"]').appendChild(errorsList);
                }
            }
        });

        form.addEventListener('freeform-remove-field-messages', (event) => {
            const field = event.field;
            const fieldType= field.getAttribute('type');

            // Remove aria attributes
            if (fieldType === 'radio') {
                const radiogroup = field.closest('[role="radiogroup"]');
                if (radiogroup) {
                    radiogroup.removeAttribute('aria-invalid');
                    radiogroup.removeAttribute('aria-describedby');
                }
            } else {
                field.removeAttribute('aria-invalid');
                field.removeAttribute('aria-describedby');
            }

            // Removing error list
            const key = field.getAttribute('name').replace(/\[]/g, '');
            const fieldContainer = field.closest('[data-field-container="'+key+'"]');
            if (fieldContainer) {
              const errorsList = fieldContainer.querySelector('[data-field-errors]');
              if (errorsList) {
                errorsList.remove();
              }
            }
        });

        // Alert screen readers to errors
        form.addEventListener('freeform-ajax-error', (event) => {
            const form = event.form;
            const options = event.freeform.options;
            const errors = event.errors;
            const formErrors = event.formErrors;
            const alertBox = form.querySelector('[data-form-messages]');

            let errorsArray = [];
            let errorsCount = 0;
            for (const [key, value] of Object.entries(errors)) {
                if (value[0] !== 'This field is required') { // default is not helpful
                    errorsArray.push(`${value[0]}`);
                }
                errorsCount = errorsCount + 1;
            }
            for (let i=0; i<formErrors.length; i++) {
                errorsArray.push(formErrors[i]);
                errorsCount = errorsCount + 1;
            }

            if (alertBox) {
                // Note: screen readers will not read out the same message twice!
                let message = (options.errorBannerMessage ?? 'Sorry, there was an error.');
                if (errorsCount > 1) {
                    message = `Sorry, there are ${errorsCount} errors in this form.`;
                } else if (errorsCount === 1) {
                    message = `Sorry, there is an error in this form.`;
                }
                message += ' ' + errorsArray.join(', ');
                alertBox.textContent = message;
            }
        });

        form.addEventListener('freeform-remove-messages', (event) => {
            const alertBox = form.querySelector('[data-form-messages]');
            if (alertBox) {
                alertBox.textContent = null;
            }
        });

        // Send a `form_submit` event to GTM
        form.addEventListener('freeform-render-success', (event) => {

            const options = event.freeform.options;

            // Alert screen readers
            const alertBox = form.querySelector('[data-form-messages]');
            if (alertBox) {
                alertBox.textContent = (options.successBannerMessage ?? 'The form was submitted successfully.');
            }

            // Send a `form_submit` event to GTM
            if (typeof gtag != "undefined") {
                let response = event.response;

                let pushEvent = form.freeform._dispatchEvent(
                    'freeform-gtm-data-layer-push',
                    {payload: {}, response: response}
                );

                let payload = {
                    event: 'form_submit',
                    eventModel: {
                        formName: form.dataset.handle,
                        eventCategory: 'Craft Forms',
                        eventAction: 'Submit',
                        eventLabel: document.location.href
                    },
                };

                payload = Object.assign(payload, pushEvent.payload);
                window.dataLayer.push(payload);
            }
        });
    }

    function configureStripe(form) {
        // Styling for Stripe Payments field
        form.addEventListener("freeform-stripe-appearance", (event) => {
            event.elementOptions.appearance = Object.assign(
                event.elementOptions.appearance,
                {
                    variables: {
                        colorPrimary: "#5A8191",
                        fontFamily: "-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\"",
                        fontSizeBase: "16px",
                        spacingUnit: "0.2em",
                        tabSpacing: "10px",
                        gridColumnSpacing: "20px",
                        gridRowSpacing: "20px",
                        colorText: "#212529",
                        colorBackground: "#ffffff",
                        colorDanger: "rgb(185 28 28)", // red-700
                        borderRadius: "5px",
                    },
                    rules: {
                        '.Tab, .Input': {
                            border: '1px solid rgb(148 163 184)',
                            boxShadow: 'none',
                        },
                        '.Tab:focus, .Input:focus': {
                            border: '1px solid #375264',
                            boxShadow: 'none',
                            outline: '0',
                            transition: 'border-color .15s ease-in-out',
                        },
                        '.Tab--selected': {
                            backgroundColor: '#a493e1', // accent-tint
                        },
                        '.Tab--selected:focus': {
                            boxShadow: 'none',
                        },
                        '.Label': {
                            fontSize: '13.5px',
                            fontWeight: '400',
                            color: '#374151', // gray.700
                            marginBottom: '0.25rem',
                            lineHeight: 1.5
                        },
                        '.Error': {
                            fontSize: '13.5px',
                            fontWeight: '300'
                        },
                        '.Input': {
                            borderColor: '#d1d5db', // gray.300
                            borderRadius: '0'
                        },
                        '.Input:focus': {
                            borderColor: '#6b7280' // gray.500
                        },
                        '.Input--invalid': {
                            boxShadow: 'none',
                            borderColor: 'var(--colorDanger)'
                        }
                    }
                }
            );
        });
    }

    return {
        init: init
    };

})();

export default Forms;